import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/main/autoreg/accounts/store/action.type";
import {AutoRegProcessItemsType} from "@/main/autoreg/registration/store/type/autoRegProcessItems.type";

export const setProcessesAction = createAction(
  ActionType.SET_PROCESSES,
  props<{payload: AutoRegProcessItemsType}>()
)
